const ARCHIVE_PAGE_RADIUS = 5;
export const ARCHIVE_PAGE_API_MAX = 100_000;

export function normalizeArchiveRequestPage(page: number): number {
  return Number.isFinite(page)
    ? Math.max(1, Math.min(ARCHIVE_PAGE_API_MAX, Math.floor(page)))
    : 1;
}

export function normalizeArchiveTotalPages(totalPages: number): number {
  return Number.isFinite(totalPages) ? Math.max(1, Math.floor(totalPages)) : 1;
}

export function normalizeArchivePage(page: number, totalPages: number): number {
  const normalizedTotalPages = normalizeArchiveTotalPages(totalPages);
  return Number.isFinite(page)
    ? Math.max(1, Math.min(normalizedTotalPages, Math.floor(page)))
    : 1;
}

export function getArchivePageRedirect(
  page: number,
  totalPages: number,
): number | null {
  const normalizedPage = normalizeArchivePage(page, totalPages);
  return normalizedPage === page ? null : normalizedPage;
}

export function getArchivePageNumbers(
  page: number,
  totalPages: number,
): number[] {
  const normalizedTotalPages = normalizeArchiveTotalPages(totalPages);
  const normalizedPage = normalizeArchivePage(page, normalizedTotalPages);
  const start = Math.max(1, normalizedPage - ARCHIVE_PAGE_RADIUS);
  const end = Math.min(
    normalizedTotalPages,
    normalizedPage + ARCHIVE_PAGE_RADIUS,
  );
  const pageNumbers: number[] = [];
  for (let pageNumber = start; pageNumber <= end; pageNumber += 1) {
    pageNumbers.push(pageNumber);
  }
  return pageNumbers;
}
